import { REPORTES } from '../actions/types';

const initialState = {
    ventana_filtros_ingresos_egresos: false,
    ventana_filtros_ventas_medicos: false,
    ventana_filtros_ventas_diarias: false,
    ventana_filtros_ventas_detalle: false,
    ventana_filtros_ventas_unidades: false,
    ventana_filtros_lineas_venta: false,
    ventana_filtros_ordenes_items: false
};

export default (state = initialState, action) => {

    const { type, payload } = action;

    switch ( type ) {
        case REPORTES.FILTROS_INGRESOS_EGRESOS:
            return {
                ...state,
                ventana_filtros_ingresos_egresos: payload
            };

        case REPORTES.FILTROS_VENTAS_MEDICOS:
            return {
                ...state,
                ventana_filtros_ventas_medicos: payload
            };

        case REPORTES.FILTROS_VENTAS_DIARIAS:
            return {
                ...state,
                ventana_filtros_ventas_diarias: payload
            };

        case REPORTES.FILTROS_VENTAS_DETALLE:
            return {
                ...state,
                ventana_filtros_ventas_detalle: payload
            };

        case REPORTES.FILTROS_VENTAS_UNIDADES:
            return {
                ...state,
                ventana_filtros_ventas_unidades: payload
            };

        case REPORTES.FILTROS_LINEAS_VENTA:
            return {
                ...state,
                ventana_filtros_lineas_venta: payload
            };

        case REPORTES.FILTROS_ORDENES_ITEMS:
            return {
                ...state,
                ventana_filtros_ordenes_items: payload
            };

        default:
            return state;
    }
}